import {configureStore} from '@reduxjs/toolkit'
import licenseReducer from "./reducers/licenseReducer";
import signExtensionReducer from "./reducers/signExtensionReducer";
import auditReducer from "./reducers/auditReducer";


const store = configureStore({
    reducer: {
        license: licenseReducer,
        signExtension: signExtensionReducer,
        audit: auditReducer
    }
});

export default store